import { Injectable, inject } from '@angular/core';
import { HTTP_AP_BulkApproveMortgageCases_Request } from '@api-new/caseservice/HTTP_AP_BulkApproveMortgageCases_Request';
import { HTTP_AP_BulkCreateMortgageCases_Request } from '@api-new/caseservice/HTTP_AP_BulkCreateMortgageCases_Request';
import { HTTP_AP_BulkUpdateMortgageCases_Request } from '@api-new/caseservice/HTTP_AP_BulkUpdateMortgageCases_Request';
import { HTTP_AP_CreateMortgageCase_Request } from '@api-new/caseservice/HTTP_AP_CreateMortgageCase_Request';
import { HTTP_AP_GetHelpCase_ForCaseDetail_Request } from '@api-new/caseservice/HTTP_AP_GetHelpCase_ForCaseDetail_Request';
import { HTTP_AP_GetMortgageCase_ForCaseDetail_Request } from '@api-new/caseservice/HTTP_AP_GetMortgageCase_ForCaseDetail_Request';
import { HTTP_AP_GetMortgageCase_ForCaseDetail_Response } from '@api-new/caseservice/HTTP_AP_GetMortgageCase_ForCaseDetail_Response';
import { HTTP_AP_GetSmartSearchCase_ForCaseDetail_Request } from '@api-new/caseservice/HTTP_AP_GetSmartSearchCase_ForCaseDetail_Request';
import { HTTP_AP_GetSmartSearchCase_ForCaseDetail_Response } from '@api-new/caseservice/HTTP_AP_GetSmartSearchCase_ForCaseDetail_Response';
import { HTTP_AP_HelpCase } from '@api-new/caseservice/HTTP_AP_HelpCase';
import { HTTP_AP_ListCases_ForApprovalRequiredTable_Request } from '@api-new/caseservice/HTTP_AP_ListCases_ForApprovalRequiredTable_Request';
import { HTTP_AP_ListCases_ForApprovalRequiredTable_Response } from '@api-new/caseservice/HTTP_AP_ListCases_ForApprovalRequiredTable_Response';
import { HTTP_AP_ListCases_ForClientDetail_Request } from '@api-new/caseservice/HTTP_AP_ListCases_ForClientDetail_Request';
import { HTTP_AP_ListCases_ForClientDetail_Response } from '@api-new/caseservice/HTTP_AP_ListCases_ForClientDetail_Response';
import { HTTP_AP_ListCases_ForClosedTable_Request } from '@api-new/caseservice/HTTP_AP_ListCases_ForClosedTable_Request';
import { HTTP_AP_ListCases_ForClosedTable_Response } from '@api-new/caseservice/HTTP_AP_ListCases_ForClosedTable_Response';
import { HTTP_AP_ListCases_ForLeadsTable_Request } from '@api-new/caseservice/HTTP_AP_ListCases_ForLeadsTable_Request';
import { HTTP_AP_ListCases_ForLeadsTable_Response } from '@api-new/caseservice/HTTP_AP_ListCases_ForLeadsTable_Response';
import { HTTP_AP_ListCases_ForOpportunitiesTable_Request } from '@api-new/caseservice/HTTP_AP_ListCases_ForOpportunitiesTable_Request';
import { HTTP_AP_ListCases_ForOpportunitiesTable_Response } from '@api-new/caseservice/HTTP_AP_ListCases_ForOpportunitiesTable_Response';
import { HTTP_AP_ListCases_ForPipelineTable_Request } from '@api-new/caseservice/HTTP_AP_ListCases_ForPipelineTable_Request';
import { HTTP_AP_ListCases_ForPipelineTable_Response } from '@api-new/caseservice/HTTP_AP_ListCases_ForPipelineTable_Response';
import { HTTP_AP_ListMortgageCases_WithStatusOpportunity_Request } from '@api-new/caseservice/HTTP_AP_ListMortgageCases_WithStatusOpportunity_Request';
import { HTTP_AP_ListMortgageCases_WithStatusOpportunity_Response } from '@api-new/caseservice/HTTP_AP_ListMortgageCases_WithStatusOpportunity_Response';
import { HTTP_AP_MortgageCase } from '@api-new/caseservice/HTTP_AP_MortgageCase';
import { HTTP_AP_UpdateHelpCase_Request } from '@api-new/caseservice/HTTP_AP_UpdateHelpCase_Request';
import { HTTP_AP_UpdateMortgageCase_Request } from '@api-new/caseservice/HTTP_AP_UpdateMortgageCase_Request';
import { HTTP_AP_UpdateSmartSearchCase_Request } from '@api-new/caseservice/HTTP_AP_UpdateSmartSearchCase_Request';
import { HTTP_AP_ValidateBulkApproveMortgageCases_Response } from '@api-new/caseservice/HTTP_AP_ValidateBulkApproveMortgageCases_Response';
import { HTTP_AP_ValidateBulkCreateMortgageCases_Response } from '@api-new/caseservice/HTTP_AP_ValidateBulkCreateMortgageCases_Response';
import { HTTP_AP_ValidateBulkUpdateMortgageCases_Response } from '@api-new/caseservice/HTTP_AP_ValidateBulkUpdateMortgageCases_Response';
import { HTTP_CP_CreateHelpCase_Request } from '@api-new/caseservice/HTTP_CP_CreateHelpCase_Request';
import { HTTP_CP_CreateSmartSearchCase_Request } from '@api-new/caseservice/HTTP_CP_CreateSmartSearchCase_Request';
import { HTTP_CP_HelpCase } from '@api-new/caseservice/HTTP_CP_HelpCase';
import { HTTP_CP_ListHelpCases_Response } from '@api-new/caseservice/HTTP_CP_ListHelpCases_Response';
import { HTTP_CP_ListMortgageCases_Response } from '@api-new/caseservice/HTTP_CP_ListMortgageCases_Response';
import { HTTP_CP_ListSmartSearchCases_Response } from '@api-new/caseservice/HTTP_CP_ListSmartSearchCases_Response';
import { HTTP_CP_MortgageCase } from '@api-new/caseservice/HTTP_CP_MortgageCase';
import { HTTP_CP_SmartSearchCase } from '@api-new/caseservice/HTTP_CP_SmartSearchCase';
import { HTTP_CP_UpdateHelpCase_Request } from '@api-new/caseservice/HTTP_CP_UpdateHelpCase_Request';
import { HTTP_CP_UpdateMortgageCase_Request } from '@api-new/caseservice/HTTP_CP_UpdateMortgageCase_Request';
import { HTTP_CP_UpdateSmartSearchCase_Request } from '@api-new/caseservice/HTTP_CP_UpdateSmartSearchCase_Request';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class CaseApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_BulkApproveMortgageCases(request: HTTP_AP_BulkApproveMortgageCases_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/case-service/ap/BulkApproveMortgageCases`, request, options);
  }

  HTTP_AP_BulkCreateMortgageCases(request: HTTP_AP_BulkCreateMortgageCases_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/case-service/ap/BulkCreateMortgageCases`, request, options);
  }

  HTTP_AP_BulkUpdateMortgageCases(request: HTTP_AP_BulkUpdateMortgageCases_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/case-service/ap/BulkUpdateMortgageCases`, request, options);
  }

  HTTP_AP_CreateMortgageCase(request: HTTP_AP_CreateMortgageCase_Request, options?: IRequestOptions): Observable<HTTP_AP_MortgageCase> {
    return this.httpClient.post(`/case-service/ap/CreateMortgageCase`, request, options);
  }

  HTTP_AP_GetHelpCase_ForCaseDetail(
    request: HTTP_AP_GetHelpCase_ForCaseDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_HelpCase> {
    return this.httpClient.get(`/case-service/ap/GetHelpCase_ForCaseDetail`, { params: request });
  }

  HTTP_AP_GetMortgageCase_ForCaseDetail(
    request: HTTP_AP_GetMortgageCase_ForCaseDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetMortgageCase_ForCaseDetail_Response> {
    return this.httpClient.get(`/case-service/ap/GetMortgageCase_ForCaseDetail`, { params: request });
  }

  HTTP_AP_GetSmartSearchCase_ForCaseDetail(
    request: HTTP_AP_GetSmartSearchCase_ForCaseDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetSmartSearchCase_ForCaseDetail_Response> {
    return this.httpClient.get(`/case-service/ap/GetSmartSearchCase_ForCaseDetail`, { params: request });
  }

  HTTP_AP_ListCases_ForApprovalRequiredTable(
    request: HTTP_AP_ListCases_ForApprovalRequiredTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCases_ForApprovalRequiredTable_Response> {
    return this.httpClient.get(`/case-service/ap/ListCases_ForApprovalRequiredTable`, { params: request });
  }

  HTTP_AP_ListCases_ForClientDetail(
    request: HTTP_AP_ListCases_ForClientDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCases_ForClientDetail_Response> {
    return this.httpClient.get(`/case-service/ap/ListCases_ForClientDetail`, { params: request });
  }

  HTTP_AP_ListCases_ForClosedTable(
    request: HTTP_AP_ListCases_ForClosedTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCases_ForClosedTable_Response> {
    return this.httpClient.get(`/case-service/ap/ListCases_ForClosedTable`, { params: request });
  }

  HTTP_AP_ListCases_ForLeadsTable(
    request: HTTP_AP_ListCases_ForLeadsTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCases_ForLeadsTable_Response> {
    return this.httpClient.get(`/case-service/ap/ListCases_ForLeadsTable`, { params: request });
  }

  HTTP_AP_ListCases_ForOpportunitiesTable(
    request: HTTP_AP_ListCases_ForOpportunitiesTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCases_ForOpportunitiesTable_Response> {
    return this.httpClient.get(`/case-service/ap/ListCases_ForOpportunitiesTable`, { params: request });
  }

  HTTP_AP_ListCases_ForPipelineTable(
    request: HTTP_AP_ListCases_ForPipelineTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCases_ForPipelineTable_Response> {
    return this.httpClient.get(`/case-service/ap/ListCases_ForPipelineTable`, { params: request });
  }

  HTTP_AP_ListMortgageCases_WithStatusOpportunity(
    request: HTTP_AP_ListMortgageCases_WithStatusOpportunity_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListMortgageCases_WithStatusOpportunity_Response> {
    return this.httpClient.get(`/case-service/ap/ListMortgageCases_WithStatusOpportunity`, { params: request });
  }

  HTTP_AP_UpdateHelpCase(request: HTTP_AP_UpdateHelpCase_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.put(`/case-service/ap/UpdateHelpCase`, request, options);
  }

  HTTP_AP_UpdateMortgageCase(request: HTTP_AP_UpdateMortgageCase_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.put(`/case-service/ap/UpdateMortgageCase`, request, options);
  }

  HTTP_AP_UpdateSmartSearchCase(request: HTTP_AP_UpdateSmartSearchCase_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.put(`/case-service/ap/UpdateSmartSearchCase`, request, options);
  }

  HTTP_AP_ValidateBulkApproveMortgageCases(
    request: HTTP_AP_BulkApproveMortgageCases_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ValidateBulkApproveMortgageCases_Response> {
    return this.httpClient.post(`/case-service/ap/ValidateBulkApproveMortgageCases`, request, options);
  }

  HTTP_AP_ValidateBulkCreateMortgageCases(
    request: HTTP_AP_BulkCreateMortgageCases_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ValidateBulkCreateMortgageCases_Response> {
    return this.httpClient.post(`/case-service/ap/ValidateBulkCreateMortgageCases`, request, options);
  }

  HTTP_AP_ValidateBulkUpdateMortgageCases(
    request: HTTP_AP_BulkUpdateMortgageCases_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ValidateBulkUpdateMortgageCases_Response> {
    return this.httpClient.post(`/case-service/ap/ValidateBulkUpdateMortgageCases`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_CreateHelpCase(request: HTTP_CP_CreateHelpCase_Request, options?: IRequestOptions): Observable<HTTP_CP_HelpCase> {
    return this.httpClient.post(`/case-service/cp/CreateHelpCase`, request, options);
  }

  HTTP_CP_CreateSmartSearchCase(
    request: HTTP_CP_CreateSmartSearchCase_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_SmartSearchCase> {
    return this.httpClient.post(`/case-service/cp/CreateSmartSearchCase`, request, options);
  }

  HTTP_CP_ListHelpCases(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListHelpCases_Response> {
    return this.httpClient.get(`/case-service/cp/ListHelpCases`, { params: request });
  }

  HTTP_CP_ListMortgageCases(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListMortgageCases_Response> {
    return this.httpClient.get(`/case-service/cp/ListMortgageCases`, { params: request });
  }

  HTTP_CP_ListSmartSearchCases(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListSmartSearchCases_Response> {
    return this.httpClient.get(`/case-service/cp/ListSmartSearchCases`, { params: request });
  }

  HTTP_CP_UpdateHelpCase(request: HTTP_CP_UpdateHelpCase_Request, options?: IRequestOptions): Observable<HTTP_CP_HelpCase> {
    return this.httpClient.put(`/case-service/cp/UpdateHelpCase`, request, options);
  }

  HTTP_CP_UpdateMortgageCase(request: HTTP_CP_UpdateMortgageCase_Request, options?: IRequestOptions): Observable<HTTP_CP_MortgageCase> {
    return this.httpClient.put(`/case-service/cp/UpdateMortgageCase`, request, options);
  }

  HTTP_CP_UpdateSmartSearchCase(
    request: HTTP_CP_UpdateSmartSearchCase_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_SmartSearchCase> {
    return this.httpClient.put(`/case-service/cp/UpdateSmartSearchCase`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/case-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
}
